import { PlatformFilter } from 'state/blotters/common/blotter.model';
import {
  Blotter,
  DlpProductsBlotter,
  DlpProductsTradesBlotter,
  ProductBlotter,
  TradeBlotter,
} from 'state/blotters/trades/types/blotter';
import { TradesBlottersItem } from 'state/blotters/trades/types/blotterItem';
import {
  CommonTradesBlottersFilters,
  GlobalFilters,
  TradesOrProductsBlotterFilters,
} from 'state/blotters/trades/types/filters';
import { FilterBlotterType } from 'state/blotters/trades/types/types';

export type TradesBlotters = {
  trades: TradeBlotter;
  products: ProductBlotter;
  dlpProducts: DlpProductsBlotter;
  dlpProductTrades: DlpProductsTradesBlotter;
};
export interface TradesBlottersState {
  filters: GlobalFilters;
  blotters: TradesBlotters;

  availablePlatforms: ReadonlyArray<PlatformFilter> | null;
  availablePlatformsFetchingStatus: 'loading' | 'error' | 'success' | null;
}
const initialBaseBlotterState = {
  page: 1,
  loading: false,
  error: false,
  columnDefinition: [],
  sort: [],
};
const initialBlotterState = {
  ...initialBaseBlotterState,
  blotterPreferenceState: {
    columnState: [],
    pageSizeState: 25,
  },
  creditCheckStatus: undefined,
  areBlotterPreferencesInError: false,
  canSaveBlotterPreferences: false,
};
const generateInitialBlotterState = <
  I extends TradesBlottersItem,
  F extends CommonTradesBlottersFilters,
  T extends Partial<Blotter<I, F>>,
>(
  customState: T,
) => ({
  ...initialBlotterState,
  ...customState,
});
const initialTradesBlotterFilters: CommonTradesBlottersFilters = {
  activityFilter: 'mySelf',
  quickSearchTerm: '',
  advancedFilters: false,
  dateFilter: 'today',
};
const initialTradesOrProductsBlotterFilters: TradesOrProductsBlotterFilters = {
  ...initialTradesBlotterFilters,
  advancedFilters: false,
  currencyFilter: 'allCurrencies',
  dateFilter: 'today',
  productFilter: 'allProducts',
  platformFilter: 'allPlatforms',
};
export const initialTradesBlottersFilters = {
  global: { blotterType: 'trades' as FilterBlotterType },
  blotters: {
    trades: initialTradesOrProductsBlotterFilters,
    products: initialTradesOrProductsBlotterFilters,
    dlpProducts: initialTradesBlotterFilters,
  },
};
export const initialTradesBlottersState: TradesBlottersState = {
  filters: initialTradesBlottersFilters.global,
  availablePlatforms: null,
  availablePlatformsFetchingStatus: null,
  blotters: {
    dlpProducts: { ...initialBlotterState, filters: initialTradesBlottersFilters.blotters.dlpProducts },
    products: generateInitialBlotterState({
      creditCheckStatus: undefined,
      filters: initialTradesBlottersFilters.blotters.products,
    } satisfies Partial<TradeBlotter>),
    trades: generateInitialBlotterState({
      filters: initialTradesBlottersFilters.blotters.trades,
    } satisfies Partial<ProductBlotter>),
    dlpProductTrades: { ...initialBlotterState, innerBlotters: {} },
  },
};
